/* ============================================================
   BUTIK LALEYA - Theme JavaScript (Fixed v2)
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================================
  // LANGUAGE POP-UP
  // ============================================================
  const LANG_KEY = 'butiklaleya_lang';
  const langPopupOverlay = document.getElementById('langPopupOverlay');
  const langOptions = document.querySelectorAll('.lang-option');
  const langConfirmBtn = document.getElementById('langConfirmBtn');
  const langCloseBtn = document.getElementById('langCloseBtn');

  let selectedLang = localStorage.getItem(LANG_KEY) || null;

  if (!selectedLang && langPopupOverlay) {
    setTimeout(() => { langPopupOverlay.classList.add('active'); }, 1200);
  } else if (selectedLang) {
    applyLanguage(selectedLang);
    langOptions.forEach(opt => {
      if (opt.dataset.lang === selectedLang) opt.classList.add('selected');
    });
  }

  langOptions.forEach(opt => {
    opt.addEventListener('click', function () {
      langOptions.forEach(o => o.classList.remove('selected'));
      this.classList.add('selected');
      selectedLang = this.dataset.lang;
    });
  });

  if (langConfirmBtn) {
    langConfirmBtn.addEventListener('click', function () {
      if (selectedLang) {
        localStorage.setItem(LANG_KEY, selectedLang);
        langPopupOverlay.classList.remove('active');
        applyLanguage(selectedLang);
      } else {
        langConfirmBtn.style.animation = 'shake 0.3s ease';
        setTimeout(() => langConfirmBtn.style.animation = '', 300);
      }
    });
  }

  if (langCloseBtn) {
    langCloseBtn.addEventListener('click', () => langPopupOverlay.classList.remove('active'));
  }

  if (langPopupOverlay) {
    langPopupOverlay.addEventListener('click', function (e) {
      if (e.target === langPopupOverlay) langPopupOverlay.classList.remove('active');
    });
  }

  function applyLanguage(lang) {
    const translations = {
      bs: {
        nav_home: 'Početna', nav_new: 'Novo', nav_women: 'Žene', nav_men: 'Muškarci',
        nav_sale: 'Rasprodaja', nav_about: 'O nama',
        hero_badge: 'Nova kolekcija 2025',
        hero_title: 'Pronađi svoj\njedinstveni stil',
        hero_subtitle: 'Ekskluzivna moda za svaku prigodu. Otkrijte najnovije trendove u Butik Laleya.',
        hero_btn1: 'Istražite kolekciju', hero_btn2: 'Novo u ponudi',
        add_to_cart: 'Dodaj u košaricu', buy_now: 'Kupi odmah',
        free_shipping: 'Besplatna dostava', easy_returns: 'Lako vraćanje',
        secure_payment: 'Sigurno plaćanje', support_24_7: 'Podrška 24/7',
        footer_copy: '© 2025 Butik Laleya. Sva prava zadržana.',
      },
      en: {
        nav_home: 'Home', nav_new: 'New In', nav_women: 'Women', nav_men: 'Men',
        nav_sale: 'Sale', nav_about: 'About',
        hero_badge: 'New Collection 2025',
        hero_title: 'Find Your\nUnique Style',
        hero_subtitle: 'Exclusive fashion for every occasion. Discover the latest trends at Butik Laleya.',
        hero_btn1: 'Explore Collection', hero_btn2: 'New Arrivals',
        add_to_cart: 'Add to Cart', buy_now: 'Buy Now',
        free_shipping: 'Free Shipping', easy_returns: 'Easy Returns',
        secure_payment: 'Secure Payment', support_24_7: '24/7 Support',
        footer_copy: '© 2025 Butik Laleya. All rights reserved.',
      },
      de: {
        nav_home: 'Startseite', nav_new: 'Neu', nav_women: 'Damen', nav_men: 'Herren',
        nav_sale: 'Sale', nav_about: 'Über uns',
        hero_badge: 'Neue Kollektion 2025',
        hero_title: 'Finde deinen\neinzigartigen Stil',
        hero_subtitle: 'Exklusive Mode für jeden Anlass. Entdecke die neuesten Trends bei Butik Laleya.',
        hero_btn1: 'Kollektion entdecken', hero_btn2: 'Neuheiten',
        add_to_cart: 'In den Warenkorb', buy_now: 'Jetzt kaufen',
        free_shipping: 'Kostenloser Versand', easy_returns: 'Einfache Rückgabe',
        secure_payment: 'Sichere Zahlung', support_24_7: '24/7 Support',
        footer_copy: '© 2025 Butik Laleya. Alle Rechte vorbehalten.',
      },
      fr: {
        nav_home: 'Accueil', nav_new: 'Nouveautés', nav_women: 'Femmes', nav_men: 'Hommes',
        nav_sale: 'Soldes', nav_about: 'À propos',
        hero_badge: 'Nouvelle Collection 2025',
        hero_title: 'Trouvez votre\nstyle unique',
        hero_subtitle: 'Mode exclusive pour chaque occasion. Découvrez les dernières tendances chez Butik Laleya.',
        hero_btn1: 'Explorer la collection', hero_btn2: 'Nouveautés',
        add_to_cart: 'Ajouter au panier', buy_now: 'Acheter maintenant',
        free_shipping: 'Livraison gratuite', easy_returns: 'Retours faciles',
        secure_payment: 'Paiement sécurisé', support_24_7: 'Support 24/7',
        footer_copy: '© 2025 Butik Laleya. Tous droits réservés.',
      }
    };

    const t = translations[lang] || translations['bs'];
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.dataset.i18n;
      if (t[key]) {
        if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
          el.placeholder = t[key];
        } else {
          el.textContent = t[key];
        }
      }
    });

    const currentLangEl = document.getElementById('currentLang');
    const flags = { bs: '🇧🇦 BS', en: '🇬🇧 EN', de: '🇩🇪 DE', fr: '🇫🇷 FR' };
    if (currentLangEl) currentLangEl.textContent = flags[lang] || '🌍 BS';
    document.documentElement.lang = lang;
  }

  // ============================================================
  // COUNTDOWN TIMER
  // ============================================================
  const timerEl = document.getElementById('countdown');
  if (timerEl) {
    const TIMER_KEY = 'butiklaleya_timer_end';
    let endTime = parseInt(localStorage.getItem(TIMER_KEY) || '0');
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem(TIMER_KEY, endTime);
    }
    function updateTimer() {
      const remaining = endTime - Date.now();
      if (remaining <= 0) { timerEl.innerHTML = '<span>00</span>:<span>00</span>:<span>00</span>'; return; }
      const pad = n => String(n).padStart(2, '0');
      timerEl.innerHTML = `<span>${pad(Math.floor(remaining / 3600000))}</span>:<span>${pad(Math.floor((remaining % 3600000) / 60000))}</span>:<span>${pad(Math.floor((remaining % 60000) / 1000))}</span>`;
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // ============================================================
  // MOBILE MENU
  // ============================================================
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileMenuClose = document.getElementById('mobileMenuClose');
  const drawerOverlay = document.getElementById('drawerOverlay');

  function openMobileMenu() {
    mobileMenu && mobileMenu.classList.add('open');
    drawerOverlay && drawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu && mobileMenu.classList.remove('open');
    if (!cartDrawer?.classList.contains('open')) {
      drawerOverlay && drawerOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  hamburger && hamburger.addEventListener('click', openMobileMenu);
  mobileMenuClose && mobileMenuClose.addEventListener('click', closeMobileMenu);

  // ============================================================
  // CART DRAWER - AJAX (Shopify Cart API)
  // ============================================================
  const cartBtn = document.getElementById('cartBtn');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartCloseBtn = document.getElementById('cartCloseBtn');
  const cartItemsContainer = document.getElementById('cartItemsContainer');
  const cartFooter = document.getElementById('cartFooter');
  const cartCount = document.querySelector('.cart-count');

  function openCart() {
    refreshCart();
    cartDrawer && cartDrawer.classList.add('open');
    drawerOverlay && drawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    if (!mobileMenu?.classList.contains('open')) {
      drawerOverlay && drawerOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  cartBtn && cartBtn.addEventListener('click', openCart);
  cartCloseBtn && cartCloseBtn.addEventListener('click', closeCart);
  drawerOverlay && drawerOverlay.addEventListener('click', () => { closeMobileMenu(); closeCart(); });

  function updateCartCount(count) {
    if (cartCount) {
      cartCount.textContent = count;
      cartCount.style.display = count > 0 ? 'flex' : 'none';
      cartCount.style.transform = 'scale(1.4)';
      setTimeout(() => cartCount.style.transform = '', 300);
    }
  }

  function updateProgressBar(totalPrice) {
    const FREE_SHIPPING = 29900; // 299 KM in cents
    const progressFill = document.querySelector('.cart-progress-fill');
    const progressText = document.querySelector('.cart-progress-bar span');
    if (!progressFill) return;
    progressFill.style.width = Math.min((totalPrice / FREE_SHIPPING) * 100, 100) + '%';
    if (progressText) {
      if (totalPrice >= FREE_SHIPPING) {
        progressText.innerHTML = '🎉 Čestitamo! Imate <strong>besplatnu dostavu</strong>!';
      } else {
        const remaining = ((FREE_SHIPPING - totalPrice) / 100).toFixed(0);
        progressText.innerHTML = `Dodajte još <strong>${remaining} KM</strong> za besplatnu dostavu!`;
      }
    }
  }

  function formatMoney(cents) {
    return 'KM ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderCartItems(cart) {
    if (!cartItemsContainer) return;
    if (cart.item_count === 0) {
      cartItemsContainer.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty-icon">🛍️</div>
          <h4>Vaša košarica je prazna</h4>
          <p>Dodajte neke predivne komade iz naše kolekcije!</p>
          <a href="/collections/all" class="btn-primary">Istražite kolekciju</a>
        </div>`;
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    let html = '';
    cart.items.forEach(item => {
      const imgSrc = item.image
        ? item.image.replace(/(\.[^.?]+)(\?.*)?$/, '_80x80_crop_center$1')
        : 'https://via.placeholder.com/80';
      html += `
        <div class="cart-item" data-key="${item.key}">
          <a href="${item.url}" class="cart-item-img-wrap">
            <img src="${imgSrc}" alt="${item.title}" width="80" height="80">
          </a>
          <div class="cart-item-info">
            <div class="cart-item-top-row">
              <a href="${item.url}" class="cart-item-title">${item.product_title}</a>
              <button class="cart-item-remove" data-key="${item.key}" aria-label="Ukloni">🗑</button>
            </div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
            <div class="cart-item-row">
              <div class="cart-item-qty">
                <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Smanji">−</button>
                <span class="qty-val">${item.quantity}</span>
                <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Povećaj">+</button>
              </div>
              <span class="cart-item-price">${formatMoney(item.line_price)}</span>
            </div>
          </div>
        </div>`;
    });

    cartItemsContainer.innerHTML = html;
    if (cartFooter) {
      cartFooter.style.display = 'block';
      const subtotalEl = cartFooter.querySelector('.cart-subtotal-price');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }

    cartItemsContainer.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        updateCartItem(this.dataset.key, parseInt(this.dataset.qty));
      });
    });
    cartItemsContainer.querySelectorAll('.cart-item-remove').forEach(btn => {
      btn.addEventListener('click', function () { updateCartItem(this.dataset.key, 0); });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(r => r.json()).then(cart => {
      updateCartCount(cart.item_count);
      renderCartItems(cart);
      updateProgressBar(cart.total_price);
    });
  }

  function refreshCart() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      updateCartCount(cart.item_count);
      renderCartItems(cart);
      updateProgressBar(cart.total_price);
    }).catch(() => {});
  }

  // ============================================================
  // ADD TO CART - AJAX (Collection & Homepage cards)
  // ============================================================
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.add-to-cart-btn[data-variant-id], .col-add-btn[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const originalText = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    }).then(r => r.json()).then(() => {
      btn.textContent = '✓ Dodano!';
      btn.style.background = '#27ae60';
      btn.disabled = false;
      setTimeout(() => { btn.textContent = originalText; btn.style.background = ''; }, 2000);
      return fetch('/cart.js').then(r => r.json());
    }).then(cart => {
      updateCartCount(cart.item_count);
      renderCartItems(cart);
      updateProgressBar(cart.total_price);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
    }).catch(err => {
      console.error('Add to cart error:', err);
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });

  // ============================================================
  // PRODUCT PAGE - VARIANT SELECTION & ADD TO CART & BUY NOW
  // ============================================================
  const productForm = document.getElementById('product-form');
  if (productForm) {
    const variantIdInput = productForm.querySelector('input[name="id"]');
    const addToCartBtn = productForm.querySelector('.add-to-cart-btn');
    const buyNowBtn = productForm.querySelector('.buy-now-btn');

    // Variant radio selection - update hidden ID input
    productForm.querySelectorAll('.variant-option-group').forEach(group => {
      group.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', function () {
          // Visual update
          group.querySelectorAll('label span').forEach(s => {
            s.style.borderColor = '';
            s.style.background = '';
            s.style.color = '';
          });
          const span = this.nextElementSibling;
          if (span) {
            span.style.borderColor = 'var(--color-accent)';
            span.style.background = 'var(--color-accent)';
            span.style.color = 'white';
          }
          updateSelectedVariant();
        });
      });
    });

    function updateSelectedVariant() {
      const productData = window.__productData;
      if (!productData) return;
      const selectedOptions = [];
      productForm.querySelectorAll('.variant-option-group').forEach(group => {
        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) selectedOptions.push(checked.value);
      });
      if (selectedOptions.length === 0) return;
      const variant = productData.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
      if (variant && variantIdInput) {
        variantIdInput.value = variant.id;
        const priceEl = document.getElementById('product-price');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (addToCartBtn) {
          addToCartBtn.disabled = !variant.available;
          addToCartBtn.textContent = variant.available ? 'Dodaj u košaricu' : 'Rasprodano';
        }
        if (buyNowBtn) buyNowBtn.disabled = !variant.available;
      }
    }

    // Add to cart from product page
    let _addingToCart = false; // guard protiv duplog klika
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (_addingToCart) return; // spriječi dupli add
        const variantId = variantIdInput ? variantIdInput.value : null;
        if (!variantId) return;
        _addingToCart = true;
        this.textContent = 'Dodavanje...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        }).then(r => r.json()).then(() => {
          this.textContent = '\u2713 Dodano!';
          this.style.background = '#27ae60';
          this.disabled = false;
          setTimeout(() => {
            this.textContent = 'Dodaj u ko\u0161aricu';
            this.style.background = '';
            _addingToCart = false;
          }, 2000);
          return fetch('/cart.js').then(r => r.json());
        }).then(cart => {
          updateCartCount(cart.item_count);
          renderCartItems(cart);
          updateProgressBar(cart.total_price);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
        }).catch(err => {
          console.error('Add to cart error:', err);
          this.textContent = 'Dodaj u ko\u0161aricu';
          this.style.background = '';
          this.disabled = false;
          _addingToCart = false;
        });
      });
    }

    // Buy Now button
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const variantId = variantIdInput ? variantIdInput.value : null;
        if (!variantId) return;
        this.textContent = '...';
        this.disabled = true;

        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
          }))
          .then(() => { window.location.href = '/checkout'; })
          .catch(err => {
            console.error('Buy now error:', err);
            this.textContent = 'Kupi odmah';
            this.disabled = false;
          });
      });
    }
  }

  // ============================================================
  // PRODUCT IMAGE GALLERY (product page thumbnails)
  // ============================================================
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.getElementById('product-main-image');
      if (mainImg) {
        mainImg.src = this.dataset.src;
        document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });

  // ============================================================
  // TESTIMONIALS AUTO-SCROLL
  // ============================================================
  const track = document.querySelector('.testimonials-track');
  if (track) {
    const items = track.innerHTML;
    track.innerHTML = items + items;
  }

  // ============================================================
  // SCROLL REVEAL ANIMATIONS
  // ============================================================
  const revealElements = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  revealElements.forEach(el => observer.observe(el));

  // ============================================================
  // NEWSLETTER FORM
  // ============================================================
  const newsletterForm = document.getElementById('newsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = this.querySelector('input[type="email"]').value;
      if (email) this.innerHTML = '<p style="color:var(--color-secondary);font-weight:600;padding:14px;">✓ Hvala! Uspješno ste se prijavili.</p>';
    });
  }

  // ============================================================
  // STICKY HEADER SHADOW
  // ============================================================
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (header) header.style.boxShadow = window.scrollY > 50 ? '0 4px 20px rgba(0,0,0,0.1)' : '0 2px 10px rgba(0,0,0,0.05)';
  });

  // ============================================================
  // PRODUCT WISHLIST
  // ============================================================
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-action-btn[data-wishlist]');
    if (!btn) return;
    btn.textContent = btn.textContent === '♡' ? '♥' : '♡';
    btn.style.color = btn.textContent === '♥' ? '#e74c3c' : '';
  });

  // ============================================================
  // LANGUAGE DROPDOWN IN HEADER
  // ============================================================
  const langDropdownBtn = document.getElementById('langDropdownBtn');
  const langDropdown = document.getElementById('langDropdown');
  if (langDropdownBtn && langDropdown) {
    langDropdownBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      langDropdown.classList.toggle('open');
    });
    document.addEventListener('click', () => langDropdown.classList.remove('open'));
  }
  document.querySelectorAll('.lang-dropdown-item[data-switch-lang]').forEach(item => {
    item.addEventListener('click', function () {
      const lang = this.dataset.switchLang;
      localStorage.setItem(LANG_KEY, lang);
      applyLanguage(lang);
      langDropdown && langDropdown.classList.remove('open');
    });
  });

  // Initial cart sync on page load — učitaj i prikaži stavke iz Shopify sesije
  fetch('/cart.js').then(r => r.json()).then(cart => {
    updateCartCount(cart.item_count);
    if (cart.item_count > 0) {
      renderCartItems(cart);
      updateProgressBar(cart.total_price);
    }
  }).catch(() => {});

  console.log('Butik Laleya theme v2 loaded ✓');
});

// ============================================================
// EXTRA STYLES (injected)
// ============================================================
const extraStyles = document.createElement('style');
extraStyles.textContent = `
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-8px); }
    75% { transform: translateX(8px); }
  }
  .lang-dropdown { position: relative; }
  .lang-dropdown-menu {
    position: absolute; top: calc(100% + 8px); right: 0;
    background: white; border: 1px solid var(--color-border);
    border-radius: 8px; box-shadow: var(--shadow-hover);
    min-width: 140px; overflow: hidden; display: none; z-index: 100;
  }
  .lang-dropdown.open .lang-dropdown-menu { display: block; }
  .lang-dropdown-item {
    display: flex; align-items: center; gap: 10px;
    padding: 12px 16px; font-size: 13px; cursor: pointer; transition: background 0.2s;
  }
  .lang-dropdown-item:hover { background: var(--color-light); }
  /* Cart items */
  .cart-item {
    display: flex; gap: 12px; padding: 16px 0;
    border-bottom: 1px solid var(--color-border);
  }
  .cart-item-img-wrap img { width: 80px; height: 80px; object-fit: cover; border-radius: 6px; }
  .cart-item-info { flex: 1; min-width: 0; }
  .cart-item-top-row {
    display: flex; align-items: flex-start; gap: 6px;
    justify-content: space-between; margin-bottom: 4px;
  }
  .cart-item-title {
    font-weight: 600; font-size: 13px; color: var(--color-primary);
    text-decoration: none; display: -webkit-box;
    -webkit-line-clamp: 2; -webkit-box-orient: vertical;
    overflow: hidden; line-height: 1.35;
    flex: 1; min-width: 0;
  }
  .cart-item-variant { font-size: 12px; color: var(--color-gray); margin-bottom: 8px; }
  .cart-item-row { display: flex; justify-content: space-between; align-items: center; }
  .cart-item-qty { display: flex; align-items: center; gap: 8px; }
  .qty-btn {
    width: 26px; height: 26px; border: 1px solid var(--color-border);
    background: white; border-radius: 4px; cursor: pointer;
    font-size: 16px; display: flex; align-items: center; justify-content: center;
    line-height: 1; transition: background 0.2s;
  }
  .qty-btn:hover { background: var(--color-light); }
  .qty-val { font-size: 13px; font-weight: 600; min-width: 20px; text-align: center; }
  .cart-item-price { font-weight: 700; font-size: 14px; }
  .cart-item-remove {
    flex-shrink: 0;
    background: none; border: none; cursor: pointer;
    width: 28px; height: 28px;
    display: flex; align-items: center; justify-content: center;
    border-radius: 6px;
    font-size: 15px; color: #999;
    transition: background 0.15s, color 0.15s;
    padding: 0; margin-top: -2px;
  }
  .cart-item-remove:hover { background: #fff0f0; color: #e74c3c; }
  .cart-subtotal-price { font-weight: 700; }
  /* Buy Now button */
  .buy-now-btn {
    display: block; width: 100%; padding: 16px;
    background: transparent; color: var(--color-primary);
    border: 2px solid var(--color-primary); border-radius: 6px;
    font-size: 15px; font-weight: 600; cursor: pointer;
    text-align: center; margin-top: 12px; transition: all 0.2s;
    font-family: inherit;
  }
  .buy-now-btn:hover { background: var(--color-primary); color: white; }
  .buy-now-btn:disabled { opacity: 0.5; cursor: not-allowed; }
`;
document.head.appendChild(extraStyles);

/* ============================================================
   ACCOUNT BOTTOM SHEET
   ============================================================ */
(function(){
  var btn = document.getElementById('bottomNavAccount');
  var sheet = document.getElementById('accountSheet');
  var overlay = document.getElementById('accountSheetOverlay');
  var closeBtn = document.getElementById('accountSheetClose');

  function openSheet(){
    sheet.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeSheet(){
    sheet.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', openSheet);
  if(closeBtn) closeBtn.addEventListener('click', closeSheet);
  if(overlay) overlay.addEventListener('click', closeSheet);

  // Swipe down to close
  var startY = 0;
  sheet.addEventListener('touchstart', function(e){ startY = e.touches[0].clientY; }, {passive:true});
  sheet.addEventListener('touchend', function(e){
    if(e.changedTouches[0].clientY - startY > 80) closeSheet();
  }, {passive:true});
})();

/* BOTTOM NAV CART BADGE SYNC */
(function(){
  var badge = document.getElementById('bottomCartBadge');
  function upd(n){
    badge.textContent = n;
    badge.style.display = n > 0 ? 'flex' : 'none';
  }
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ upd(c.item_count); }).catch(function(){});
  setInterval(function(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ upd(c.item_count); }).catch(function(){});
  }, 3000);
  document.addEventListener('cart:updated', function(e){ if(e.detail) upd(e.detail.item_count); });
})();
